import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';
import { organizationFeatureKey, OrganizationState } from './organization.state';

export const selectOrganizationState = createFeatureSelector<OrganizationState>(organizationFeatureKey);

export const isIntegrationActive = (integration: OrganizationSettingTypeEnum) => createSelector(selectOrganizationState, (state) => {
    return !!state.activeIntegrations[integration];
});
export const selectActiveIntegration = (integration: OrganizationSettingTypeEnum) => createSelector(selectOrganizationState, (state) => {
    return state.activeIntegrations[integration];
});
